import React from 'react'
import { t } from 'ttag'

const EnrollmentSection = ({ enrollments }) => {
  const toNumber = inp => {
    if (!inp) {
      return 'n/a'
    }

    return inp.toLocaleString()
  }
  const enrollmentYear = '2020'
  const content = () => {
    return (
      <div className="enrollments">
        <p className="instructions">{t`In ${enrollmentYear}, the enrollment at this institution was comprised of: `}</p>
        <table className="tbl enrollment-table">
          <thead>
            <tr>
              <th>{t`Degree Type`}</th>
              <th>{t`Part Time`}</th>
              <th>{t`Full Time`}</th>
              <th>{t`Total`}</th>
            </tr>
          </thead>
          <tbody>
            {enrollments.values
              .sort((a, b) => a.degreeSort > b.degreeSort)
              .map((e, idx) => (
                <tr
                  key={e.degreeType}
                  className={`${idx % 2 == 0 ? 'even' : 'odd'} ${
                    idx == 2 ? 'totalrow' : ''
                  }`}>
                  <td>{e.degreeType}</td>
                  <td>{toNumber(e.attendenceStatus.partTime)}</td>
                  <td>{toNumber(e.attendenceStatus.fullTime)}</td>
                  <td>{toNumber(e.attendenceStatus.total)}</td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    )
  }

  return (
    <div className="section enrollment-section sections">
      <h3>
        <span>{t`Enrollments`}</span>
      </h3>
      {enrollments.hasOwnProperty('values') ? (
        content()
      ) : (
        <p>{t`Enrollment data is not available for this institution`}</p>
      )}
    </div>
  )
}

export default EnrollmentSection
